import React from 'react';
import parse, { attributesToProps, domToReact } from 'html-react-parser';
import { socialCardKeys } from 'src/constants/socialcard.constant'
import dayjs from 'dayjs';

import { textColors } from 'src/constants/wall.constant';

import ReadMoreReadLess from 'src/components/componentHelper/ReadMoreReadLess'
import ClassNames from 'src/components/componentHelper/ClassNames';

const GreyPictureColoredCard = ({ cardWidth, cardItem, fontStyle, darkModeEnabled, cardFontColor, highlightColor, cardBackgroundObject, darkCardTheme, linkColor, engagementDisabled, isDateTimeDisabled, smallSize, shortenText, refresh }) => {
        
    const options = {
        replace: domNode => {
           const attribProps = attributesToProps(domNode.attribs);
    
           if (domNode.name === 'a') {
              return <a {...attribProps} style={linkColor && linkColor!=='#0b57a8'?{color: linkColor} :darkModeEnabled ? { color: '#6fb0f6' } : { color: '#0b57a8' }}>{domToReact(domNode.children, options)}</a>
           }
    
           else if(domNode.name === 'b'){
            let bStyle = highlightColor ? { backgroundColor: highlightColor } : { backgroundColor: '#fcf807' };
            if (darkModeEnabled) {
              bStyle.color = '#726c6c';
            }
            return <b style={bStyle}>{domToReact(domNode.children, options)}</b>
         }
        }
     }

    return (
        <div 
        className={ClassNames(" inline-block w-full rounded-2xl p-8 text-sm leading-6 shadow-md",(fontStyle && fontStyle!=='')?`font-${fontStyle}`:'')}
        style={
            { ...(cardBackgroundObject?cardBackgroundObject:{}), boxShadow:"rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 1px 3px 1px" }
        }
        >
                            {cardItem[socialCardKeys.messageContent] && cardItem[socialCardKeys.messageContent]!=='' &&
                          <div className="tweet-content" style={{ color: !darkModeEnabled ? (cardFontColor || textColors.black.primary) : (cardFontColor || textColors.light.primary), fontSize: !smallSize?"1.05em":"1.0em",lineHeight: !smallSize? '1.5em': '1.625em' }}>
                            {
                  shortenText?
                        <ReadMoreReadLess elementId={cardItem[socialCardKeys.uuid]}  refresh={()=>refresh()} text={`“${cardItem[socialCardKeys.messageContent]}”`} parse={parse} options={options} length={300} readMore={"Read More"} readLess={"Read Less"}/>
                        :
                        parse(`“${cardItem[socialCardKeys.messageContent]}”`, options)
            }
           
                            </div>
                            }

                            {
                  cardItem[socialCardKeys.screenshotImage] &&
                  <div className="flex justify-center w-full" >

                     <img className="w-auto h-auto rounded-md " onLoad={()=>refresh()} loading='lazy' style={{ width: '100%', borderRadius:'8px',  objectFit: 'contain' }} src={cardItem[socialCardKeys.screenshotImage]} alt="" />

                  </div>
               }

                            { (!isDateTimeDisabled && cardItem[socialCardKeys.messageTime]) ?
                            <div className="mt-3 text-xs" style={!darkModeEnabled ? { color: (cardFontColor || textColors.black.secondary) } : { color: (cardFontColor || textColors.light.secondary) }}>{dayjs(cardItem[socialCardKeys.messageTime]).locale('en').format('DD MMM YYYY')}</div>
                            :
                            null
                            }
                       
                        </div>
            )    
}

export default GreyPictureColoredCard;